import { getStorageItem, setBrowserStorageItem } from '@/modules/@common/helpers/storage';

const SELF_SERVE_DISCLAIMER_MODAL = 'SELF_SERVE_DISCLAIMER_MODAL';

const selfServeDisclaimerModalManager = {
  setSelfServeDisclaimerModalShowInfo: () => setBrowserStorageItem(SELF_SERVE_DISCLAIMER_MODAL, true),
  getSelfServeDisclaimerModalShowInfo: () => getStorageItem(SELF_SERVE_DISCLAIMER_MODAL),
};

export default selfServeDisclaimerModalManager;
